export default class MemoryStorage {
    _data;

    constructor() {
        this._data = new Map();
    }

    get length() {
        return this._data.length;
    }

    key(index) {
        let step = -1;
        for (const key of this._data.keys()) {
            step++;
            if (index == step) {
                return key;
            }
        }
        return null;
    }

    clear() {
        this._data.clear();
    }

    getItem(key) {
        return this._data.get(key);
    }

    setItem(key, value) {
        this._data.set(key, value);
    }

    removeItem(key) {
        this._data.delete(key);
    }
}